import { useCallback, useContext, useEffect, useState } from "react";
import {
  ClickMaxAmount,
  ClickMaxAmountInner,
  SwapChoose,
  SwapChooseDefault,
  SwapContent,
  SwapExchangeIcon,
  SwapInput,
  SwapInputAsset,
  SwapInputTitle,
  SwapInputWrapper,
} from "../../Swap/styled";
import { ContextProviderWrapper } from "../../../../components/Context";
import swap_exchange from "../../../../assets/Dashboard/Swap/swap_exchange.png";
import { useSelector } from "react-redux";
import { ButtonCommon } from "../../../../Layout/styled";
import ModalOverlay from "../../../../components/Common/ModalOverlay";
import ChooseToken from "../../Swap/ChooseToken";
import default_token_image from "../../../../assets/Dashboard/Common/default-token-image.png";
import { convertFixed } from "../../../../utils/convertFormatNumber";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { Controller, useForm } from "react-hook-form";
import InputCommon from "../../../../components/Common/Input";
import handleCheckPair from "../../../../utils/checkPair";
import getBalance from "../../../../utils/getBalance";
import getRatio from "../../../../utils/RatioX_Y";
import {
  ActiveBin,
  BlockChart,
  ChooseShape,
  ChooseShapeItem,
  InfoPrice,
  InputPrice,
  ItemPrice,
  PairTokens,
  SelectPrice,
  ShowChart,
  TitleChart,
  WrapActions,
  WrapChooseShape,
  WrapChooseShapeV2,
  WrapPrice,
  WrapRange,
  WrapSliderPrice,
} from "./styled";
import TabsSelector from "../../Farm/TabsSelector";
import { Slider } from "antd";
import Chart from "react-apexcharts";
import { useParams } from "react-router-dom";
import axios from "axios";
import checkAllowance from "../../../../utils/checkAllowance";
import Approve from "../../../../utils/approve";
import { convertFromWei, convertToWei } from "../../../../utils/convertNumber";
import toast from "react-hot-toast";
import { abiTraderJoe } from "./abi";
import web3 from "web3";
import getTokenInfo from "../../../../utils/checkInfoByAccount";
import { debounce } from "lodash";
import LoadingSpin from "../../../../components/Common/Loading";

declare const window: Window & typeof globalThis & { ethereum: any };

const FormAddLpV2 = ({
  slippageTolerance,
  poolDetail,
  contractAddress,
  binActive,
  setBinActive
}: any) => {
  const Web3 = new web3(window.ethereum);
  const { id } = useParams();
  const { open } = useAppKit();
  const { isMobile, theme } = useContext(ContextProviderWrapper)!;
  const { listTokens }: any = useSelector((state: any) => state.pool);
  const [openModal, setOpenModal] = useState(false);
  const [tokenX, setTokenX]: any = useState(poolDetail?.tokenX);
  const [tokenY, setTokenY]: any = useState({});
  const [typeModal, setTypeModal]: any = useState(true);
  const { address }: any = useAppKitAccount();
  const [loading, setLoading] = useState(false);
  const [amountX, setAmountX]: any = useState("");
  const [amountY, setAmountY] = useState(0);
  const { control } = useForm({ mode: "onChange" });
  const [isPair, setIsPair]: any = useState("");
  const [xBalance, setXBalance] = useState();
  const [yBalance, setYBalance] = useState();
  const [ratio, setRatio] = useState(0);
  const [shapeActive, setShapeActive] = useState(0);
  const [priceSelected, setPriceSelected] = useState(1);
  const [dataChartLiq, setDataChartLiq] = useState<any>({});
  const [datasChart, setDataChart] = useState<any>({
    series: [
      {
        name: "AVAX",
        data: [],
      },
      {
        name: "USDT",
        data: [],
      },
    ],
    options: {
      chart: {
        stacked: true,
      },
      toolbar: {
        show: false,
        enabled: false,
      },
      colors: ["#ee464a", "#4bb26c"],
      responsive: [
        {
          breakpoint: 480,
        },
      ],
      dataLabels: {
        enabled: false,
        enabledOnSeries: [1],
      },
      xaxis: {
        categories: [],
      },
      grid: {
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      yaxis: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      fill: {
        opacity: 1,
      },
    },
  });
  const [dataLiquidity, setDataLiquidity] = useState<any>(null);
  const [allowance, setAllowance] = useState<any>({
    allowanceX: 0,
    allowanceY: 0,
  });
  const [bin, setBin] = useState<any>([]);
  const [numBins, setNumBins] = useState(0);
  const [range, setRange] = useState([0, 0]);
  const [isMinPriceDisabled, setIsMinPriceDisabled] = useState(false);
  const [isMaxPriceDisabled, setIsMaxPriceDisabled] = useState(false);
  const [sigma, setSigma] = useState(0);
  const [minBinId, setMinBinId] = useState<number | null>(null);
  const [maxBinId, setMaxBinId] = useState<number | null>(null);
  useEffect(() => {
    if (poolDetail) {
      setTokenX(poolDetail?.tokenX);
      setTokenY(poolDetail?.tokenY);
    }
  }, [poolDetail]);

  const handleCallRpc = async () => {
    if (address) {
      if (tokenX?.address) {
        const X: any = await getBalance(
          address,
          tokenX?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
            ? ""
            : tokenX?.address
        );
        setXBalance(X || 0);
      }
      if (tokenY?.address) {
        const X: any = await getBalance(
          address,
          tokenY?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
            ? ""
            : tokenY?.address
        );
        setYBalance(X || 0);
      }
    }
    if (tokenX?.address && tokenY?.address) {
      const Pair: any = await handleCheckPair(
        tokenX?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
          ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
          : tokenX?.address,
        tokenY?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
          ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
          : tokenY?.address
      );

      if (Pair !== "0x0000000000000000000000000000000000000000") {
        setIsPair(Pair);
      }
    }
  };

  const handleGetDataChart = async () => {
    try {
      if (!address) return;

      const data: any = {
        userBlX: 1030113.38784204,
        userBlY: 969866.806267541,
        X_Decimals: 6,
        Y_Decimals: 6,
        X_Symbol: "USDt",
        Y_Symbol: "USDC",
        data_Chart: dataChartLiq?.data_Chart,
      };

      const xAxisData = data?.data_Chart?.xaxis || [];
      const xValData = data?.data_Chart?.yaxis?.x_val || [];
      const yValData = data?.data_Chart?.yaxis?.y_val || [];

      const dataChart = {
        series: [
          {
            name: data.X_Symbol || "AVAX",
            data: Array.isArray(xValData) ? xValData : [],
          },
          {
            name: data.Y_Symbol || "USDT",
            data: Array.isArray(yValData) ? yValData : [],
          },
        ],
        options: {
          ...datasChart.options,
          xaxis: {
            show: false,
            categories: Array.isArray(xAxisData) ? xAxisData : [],
          },
        },
      };

      setDataChart(dataChart);
      setDataLiquidity(data);
    } catch (error) {
      console.log("handleGetDataChart err", error);
    }
  };

  useEffect(() => {
    handleGetDataChart();
  }, [address, id, dataChartLiq, amountX, amountY]);

  const handleGetRatio = async () => {
    const Result = await getRatio(
      isPair,
      tokenX?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
        ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
        : tokenX?.address,
      tokenY?.address === "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
        ? "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
        : tokenY?.address
    );
    setRatio(Result || 0);
  };

  useEffect(() => {
    handleCallRpc();
  }, [tokenX, tokenY, address]);

  useEffect(() => {
    if (isPair) {
      handleGetRatio();
    }
  }, [isPair]);

  // BIN
  const handleGetDefaultBin = async () => {
    const newMinPrice = bin[0].price;
    const newMaxPrice = bin[bin.length - 1].price;
    const newMinBinId = bin[0].id;
    const newMaxBinId = bin[bin.length - 1].id;
    setRange([newMinPrice, newMaxPrice]);
    setNumBins(bin.length);
    setMinBinId(newMinBinId);
    setMaxBinId(newMaxBinId);
  };

  useEffect(() => {
    if (bin.length > 0) {
      handleGetDefaultBin();
    }
  }, [bin]);

  const findClosestBin = (price: any) => {
    return bin.reduce((prev: any, curr: any) =>
      Math.abs(curr.price - price) < Math.abs(prev.price - price) ? curr : prev
    );
  };

  const calculateNumBins = (min: any, max: any) => {
    if (bin.length === 0) return 0;
    const minBin = findClosestBin(min);
    const maxBin = findClosestBin(max);
    const minIndex = bin.findIndex((binItem: any) => binItem.id === minBin.id);
    const maxIndex = bin.findIndex((binItem: any) => binItem.id === maxBin.id);
    return maxIndex - minIndex + 1;
  };

  const onChange = (value: any) => {
    if (bin.length > 0) {
      const [minPrice, maxPrice] = value;
      setRange(value);
      const binsInRange = calculateNumBins(value[0], value[1]);
      setNumBins(binsInRange);

      const minBin = findClosestBin(minPrice);
      const maxBin = findClosestBin(maxPrice);

      // Set minBinId and maxBinId
      setMinBinId(minBin.id);
      setMaxBinId(maxBin.id);

      setIsMinPriceDisabled(value[0] > binActive?.price);
      setIsMaxPriceDisabled(value[1] < binActive?.price);
    }
  };

  const handleRewardedRange = () => {
    if (bin.length > 0) {
      const middleIndex = Math.floor(bin.length / 2);
      const middlePrice = bin[middleIndex]?.price || 0;
      setRange([middlePrice, middlePrice]);
      setNumBins(1);
    }
  };

  useEffect(() => {
    if (isMaxPriceDisabled) {
      setAmountX("0");
    }
  }, [isMaxPriceDisabled]);

  useEffect(() => {
    if (isMinPriceDisabled) {
      setAmountY(0);
    }
  }, [isMinPriceDisabled]);

  const handleMinPriceChange = (e: any) => {
    const newMin = parseFloat(e.target.value) || 0;
    setRange([newMin, range[1]]);
    if (bin.length > 0) {
      const binsInRange = calculateNumBins(newMin, range[1]);
      setNumBins(binsInRange);
    }
  };

  const handleMaxPriceChange = (e: any) => {
    const newMax = parseFloat(e.target.value) || 0;
    setRange([range[0], newMax]);
    if (bin.length > 0) {
      const binsInRange = calculateNumBins(range[0], newMax);
      setNumBins(binsInRange);
    }
  };

  const handleGetBin = async () => {
    try {
      const res = await axios.get(
        `https://ap-dev-kibble.netlify.app/api/binsPrice?pool=${id}`
      );
      if (res?.data?.binRanges) {
        setBin(res.data.binRanges);
        setBinActive(
          res.data.binRanges.find((item: any) => item.id === res.data.binActive)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetBin();
  }, []);

  const handleChangeShape = () => {
    switch (shapeActive) {
      case 1:
        return "CURVE";
      case 2:
        return "BID-ASK";
      default:
        return "SPOT";
    }
  };

  const [paramTX, setParamTx] = useState<any>([]);
  const handleCalculateLP = async () => {
    setLoading(true);
    try {
      const res: any = await axios.post(
        "https://ap-dev-kibble.netlify.app/api/calculateAddLp",
        {
          wallet: `${address.toString()}`,
          tokenX: poolDetail?.tokenX.address,
          tokenY: poolDetail?.tokenY.address,
          minBin: minBinId,
          maxBin: maxBinId,
          amountX: Number(amountX),
          amountY: Number(amountY),
          slippage: Number(slippageTolerance),
          lbBinStep: poolDetail?.lbBinStep,
          shape: handleChangeShape(),
          pairVersion: poolDetail?.version.replace(".", ""),
          sigma: sigma,
        }
      );
      if (res?.data?.data_Chart) {
        setDataChartLiq(res.data);
        if (res?.data && res?.data.ParamTX) {
          setParamTx(res?.data.ParamTX);
          setLoading(false);
        }
      } else {
        setLoading(false);
        setDataChartLiq({
          data_Chart: {
            xaxis: [],
            yaxis: {
              x_val: [],
              y_val: [],
            },
          },
        });
      }
    } catch (error) {
      console.log("Error in handleCalculateLP:", error);
      setLoading(false);
      setDataChartLiq({
        data_Chart: {
          xaxis: [],
          yaxis: {
            x_val: [],
            y_val: [],
          },
        },
      });
    }
  };

  const debouncedCalculateLP = useCallback(
    debounce(() => {
      handleCalculateLP();
    }, 500),
    [amountX, amountY, range, shapeActive, slippageTolerance, sigma]
  );

  useEffect(() => {
    if (poolDetail && (amountX || amountY || range[0] || range[1])) {
      debouncedCalculateLP();
    }
    return () => {
      debouncedCalculateLP.cancel();
    };
  }, [amountX, amountY, range, shapeActive, slippageTolerance, sigma]);

  // Get info token
  const [infoX, setInfoX] = useState<any>();
  const [infoY, setInfoY] = useState<any>();
  const handleGetInfoToken = async (tokenAddress: string, signal: number) => {
    try {
      const res = await getTokenInfo(contractAddress, tokenAddress, address);
      if (res) {
        if (signal === 1) {
          setInfoX(res);
        } else {
          setInfoY(res);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Approve
  const handleCheckAllowance = useCallback(
    async (token: string, decimals: number, signal: number) => {
      try {
        const res = await checkAllowance(token, address, contractAddress);
        if (res === undefined) {
          console.log("Allowance result is undefined");
        }

        const convertedValue = convertFromWei(res, decimals);

        setAllowance((prev: any) => ({
          ...prev,
          [signal === 1 ? "allowanceX" : "allowanceY"]: Number(convertedValue),
        }));
      } catch (error) {
        console.error("Error in handleCheckAllowance:", error);
      }
    },
    [address, allowance]
  );

  useEffect(() => {
    if (poolDetail && address) {
      // Info
      handleGetInfoToken(poolDetail?.tokenX?.address, 1);
      handleGetInfoToken(poolDetail?.tokenY?.address, 2);
      // Allowance
      handleCheckAllowance(
        poolDetail?.tokenX?.address,
        poolDetail?.tokenX?.decimals,
        1
      );
      handleCheckAllowance(
        poolDetail?.tokenY?.address,
        poolDetail?.tokenY?.decimals,
        2
      );
    }
  }, [poolDetail, address]);

  const handleApprove = async (signal: number) => {
    setLoading(true);
    try {
      const res = await Approve(
        signal === 1
          ? poolDetail?.tokenX?.address
          : poolDetail?.tokenY?.address,
        contractAddress,
        Number(
          convertToWei(
            signal === 1 ? amountX : amountY,
            signal === 1
              ? poolDetail?.tokenX.decimals
              : poolDetail?.tokenY.decimals
          )
        )
      );
      if (res && signal === 1) {
        handleCheckAllowance(
          poolDetail?.tokenX?.address,
          poolDetail?.tokenX?.decimals,
          1
        );
        setLoading(false);
      } else {
        handleCheckAllowance(
          poolDetail?.tokenY?.address,
          poolDetail?.tokenY?.decimals,
          2
        );
        setLoading(false);
      }
      handleCalculateLP();
    } catch (error) {
      console.log(error);
      toast.error("User rejected transaction");
      setLoading(false);
    }
  };

  const handleCheckNative = () => {
    if (poolDetail?.tokenX.name === "Wrapped AVAX") {
      return {
        isNative: true,
        signal: 1,
      };
    } else if (poolDetail?.tokenY.name === "Wrapped AVAX") {
      return {
        isNative: true,
        signal: 2,
      };
    } else {
      return {
        isNative: false,
        signal: 0,
      };
    }
  };

  const handleAddLiquidity = async () => {
    setLoading(true);
    try {
      if (!paramTX) {
        toast.error("ParamTX missing");
        return;
      } else if (
        Number(
          convertFixed(Number(infoY?.balanceOf) / Number(infoY?.decimals) || 0)
        ) < Number(amountY)
      ) {
        return;
      } else if (
        Number(
          convertFixed(Number(infoX?.balanceOf) / Number(infoX?.decimals) || 0)
        ) < Number(amountX)
      ) {
        return;
      }

      const gasPrice = await Web3.eth.getGasPrice();
      const contract = new Web3.eth.Contract(abiTraderJoe, contractAddress);
      const checkNative = handleCheckNative();
      try {
        if (checkNative.isNative) {
          await contract.methods
            .addLiquidityNATIVE(paramTX)
            .send({
              from: address,
              gasPrice: gasPrice.toString(),
              value:
                checkNative.signal === 1
                  ? paramTX?.amountX.toString()
                  : paramTX?.amountY.toString(),
            })
            .then(async (res: any) => {
              if (res) {
                handleGetInfoToken(poolDetail?.tokenX?.address, 1);
                handleGetInfoToken(poolDetail?.tokenY?.address, 2);
                setLoading(false);
                toast.success("Add liquidity successfully", { id: "success" });
              }
            })
            .catch((error: any) => {
              toast.error(error.message);
              setLoading(false);
            });
        } else {
          await contract.methods
            .addLiquidity(paramTX[0])
            .send({
              from: address,
              gasPrice: gasPrice.toString(),
            })
            .then(async (res: any) => {
              if (res) {
                handleGetInfoToken(poolDetail?.tokenX?.address, 1);
                handleGetInfoToken(poolDetail?.tokenY?.address, 2);
                setLoading(false);
                toast.success("Add liquidity successfully", { id: "success" });
              }
            })
            .catch((error: any) => {
              toast.error(error.message);
              setLoading(false);
            });
        }
      } catch (error: any) {
        toast.error(error.message);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      Number(
        convertFixed(Number(infoY?.balanceOf) / Number(infoY?.decimals) || 0)
      ) < Number(amountY)
    ) {
      toast.error(`Insufficient ${infoY?.symbol} balance`, {
        id: "Insufficient Y",
      });
    }
  }, [amountY]);

  useEffect(() => {
    if (
      Number(
        convertFixed(Number(infoX?.balanceOf) / Number(infoX?.decimals) || 0)
      ) < Number(amountX)
    ) {
      toast.error(`Insufficient ${infoX?.symbol} balance`, {
        id: "Insufficient X",
      });
    }
  }, [amountX]);

  return (
    <>
      <SwapContent>
        <SwapInput className={`exchange ${theme}`}>
          <SwapInputTitle className={theme}>
            <SwapInputAsset>
              <span className="font-DMMono">{infoX?.symbol}</span>
            </SwapInputAsset>
            <ClickMaxAmount>
              {!isMobile && `Balance:`}{" "}
              {convertFixed(
                Number(infoX?.balanceOf) / Number(infoX?.decimals) || 0
              )}{" "}
              |{" "}
              <span
                onClick={() => {
                  setAmountX(
                    Number(
                      convertFixed(
                        Number(infoX?.balanceOf) / Number(infoX?.decimals) || 0
                      )
                    )
                  );
                }}
              >
                MAX
              </span>
            </ClickMaxAmount>
          </SwapInputTitle>
          <SwapInputWrapper className={`${theme} row-between`} active={false}>
            <SwapChoose
              className={theme}
              onClick={() => {
                setOpenModal(true);
                setTypeModal(true);
              }}
            >
              <SwapChooseDefault className={theme}>
                <img
                  src={tokenX?.img || default_token_image}
                  alt="icon"
                  onError={(e) => (e.currentTarget.src = default_token_image)}
                />
                <p>{tokenX?.symbol}</p>
              </SwapChooseDefault>
            </SwapChoose>
            <Controller
              name="token0"
              control={control}
              render={({ field }: any) => (
                <InputCommon
                  {...field}
                  disabled={isMaxPriceDisabled || !address}
                  value={amountX}
                  type="number"
                  onChange={(e: any) => {
                    setAmountX(e.target.value);
                  }}
                  placeHolder={"0"}
                />
              )}
            />
          </SwapInputWrapper>
        </SwapInput>
        <SwapExchangeIcon className={theme}>
          <img src={swap_exchange} alt="exchange" />
        </SwapExchangeIcon>
        <SwapInput className={theme}>
          <SwapInputTitle>
            <SwapInputAsset>
              <span className="font-DMMono">{infoY?.symbol}</span>
            </SwapInputAsset>
            <ClickMaxAmount>
              <ClickMaxAmountInner>
                {!isMobile && "Balance:"}{" "}
                {convertFixed(
                  Number(infoY?.balanceOf) / Number(infoY?.decimals) || 0
                )}{" "}
                |{" "}
                <span
                  onClick={() => {
                    setAmountY(
                      Number(
                        convertFixed(
                          Number(infoY?.balanceOf) / Number(infoY?.decimals) ||
                            0
                        )
                      )
                    );
                  }}
                >
                  MAX
                </span>
              </ClickMaxAmountInner>
            </ClickMaxAmount>
          </SwapInputTitle>
          <SwapInputWrapper
            className={`${theme} row-between`}
            style={{}}
            active={false}
          >
            <SwapChoose
              className={theme}
              onClick={() => {
                setOpenModal(true);
                setTypeModal(false);
              }}
            >
              <SwapChooseDefault className={theme}>
                <img
                  src={tokenY?.img || default_token_image}
                  alt="icon"
                  onError={(e) => (e.currentTarget.src = default_token_image)}
                />
                <p>{tokenY?.symbol}</p>
              </SwapChooseDefault>
            </SwapChoose>
            <Controller
              name="token1"
              control={control}
              render={({ field }: any) => (
                <InputCommon
                  {...field}
                  value={amountY}
                  onChange={(e: any) => {
                    setAmountY(e.target.value);
                  }}
                  type="number"
                  placeHolder={"0"}
                  disabled={isMinPriceDisabled}
                />
              )}
            />
          </SwapInputWrapper>
        </SwapInput>
        <WrapChooseShape>
          <h1>Choose Liquidity Shape</h1>
          <ChooseShape className="row-center">
            {LIST_SHAPE.map((item: any, index: number) => (
              <ChooseShapeItem
                style={{
                  border:
                    index === shapeActive
                      ? "1px solid #bb4bf7"
                      : "1px solid #4d4d57",
                }}
                className="row-center"
                key={index}
                onClick={() => {
                  setShapeActive(index);
                }}
              >
                <div className="img-shape row-center">
                  <img src={item.img} alt="img" />
                </div>
                <p>{item.label}</p>
              </ChooseShapeItem>
            ))}
          </ChooseShape>
        </WrapChooseShape>
        <SelectPrice className="row-between">
          <h1>Price</h1>
          <ItemPrice>
            <TabsSelector
              data={TabsListPrice}
              callBack={(item: any) => {
                setPriceSelected(1);
              }}
              active={priceSelected}
            />
          </ItemPrice>
        </SelectPrice>
        {priceSelected === 1 ? (
          <WrapChooseShape>
            <WrapRange>
              <ActiveBin>
                <p>
                  Active Bin Range: {bin[bin.length - 1]?.price} USDC per AVAX
                </p>
              </ActiveBin>
              <WrapSliderPrice>
                <div
                  style={{
                    pointerEvents: "none",
                  }}
                  className="line"
                ></div>
                <Slider
                  range={{ draggableTrack: false }}
                  min={bin.length > 0 ? bin[0]?.price : 0}
                  max={bin.length > 0 ? bin[bin.length - 1]?.price : 0}
                  value={range}
                  step={
                    bin.length > 0
                      ? (bin[bin.length - 1]?.price - bin[0]?.price) /
                        (bin.length - 1)
                      : 0
                  }
                  onChange={onChange}
                  className="custom-slider"
                  disabled={bin.length === 0}
                />
              </WrapSliderPrice>
            </WrapRange>
            <WrapPrice className="row-left">
              <InfoPrice>
                <p>Min Price</p>
                <InputPrice className="row-between">
                  <input
                    type="number"
                    value={range[0] || ""}
                    onChange={handleMinPriceChange}
                    step="0.00000000000001"
                    readOnly
                  />
                  <h2>
                    {poolDetail?.tokenX?.symbol}/{poolDetail?.tokenY?.symbol}
                  </h2>
                </InputPrice>
              </InfoPrice>
              <InfoPrice>
                <p>Max Price</p>
                <InputPrice className="row-between">
                  <input
                    type="number"
                    value={range[1] || ""}
                    onChange={handleMaxPriceChange}
                    step="0.00000000000001"
                    readOnly
                  />
                  <h2>
                    {poolDetail?.tokenX?.symbol}/{poolDetail?.tokenY?.symbol}
                  </h2>
                </InputPrice>
              </InfoPrice>
              <InfoPrice>
                <p>Num Bins</p>
                <InputPrice className="row-center">
                  <input type="number" value={numBins} readOnly />
                </InputPrice>
              </InfoPrice>
            </WrapPrice>
          </WrapChooseShape>
        ) : (
          <WrapChooseShapeV2>
            <WrapPrice className="row-left">
              <InfoPrice>
                <p>Target Price:</p>
                <InputPrice className="row-between">
                  <input type="number" name="" id="" />
                  <h2>
                    {poolDetail?.tokenX?.symbol}/{poolDetail?.tokenY?.symbol}
                  </h2>
                </InputPrice>
              </InfoPrice>
              <InfoPrice>
                <p>Radius (number of bins):</p>
                <InputPrice className="row-between">
                  <input type="number" name="" id="" />
                </InputPrice>
              </InfoPrice>
            </WrapPrice>
            <WrapPrice className="row-left">
              <InfoPrice>
                <p>Range Min:</p>
                <InputPrice className="row-between">
                  <input type="number" name="" id="" />
                  <h2>
                    {poolDetail?.tokenX?.symbol}/{poolDetail?.tokenY?.symbol}
                  </h2>
                </InputPrice>
              </InfoPrice>
              <InfoPrice>
                <p>Range Max:</p>
                <InputPrice className="row-between">
                  <input type="number" name="" id="" />
                  <h2>
                    {poolDetail?.tokenX?.symbol}/{poolDetail?.tokenY?.symbol}
                  </h2>
                </InputPrice>
              </InfoPrice>
            </WrapPrice>
            <WrapPrice className="row-left">
              <InfoPrice>
                <p>Num Bins:</p>
                <InputPrice className="row-between">
                  <input type="number" name="" id="" />
                </InputPrice>
              </InfoPrice>
              <InfoPrice>
                <p>Pct Range</p>
                <InputPrice className="row-between">
                  <input type="number" name="" id="" />
                </InputPrice>
              </InfoPrice>
            </WrapPrice>
          </WrapChooseShapeV2>
        )}
        <WrapActions className="row-right">
          <h1
            onClick={() => {
              handleRewardedRange();
            }}
          >
            Select rewarded range
          </h1>
          <h1
            onClick={() => {
              handleGetDefaultBin();
            }}
          >
            Reset price
          </h1>
        </WrapActions>
        {!Number(amountX) && !Number(amountY) ? (
          <></>
        ) : (
          <BlockChart
            style={{
              marginBottom: "20px",
            }}
          >
            <TitleChart className="row-between">
              <h1>My Liquidity</h1>
              <PairTokens className="row-right">
                <div className="row-right">
                  <div
                    style={{
                      background: "#ee464a",
                    }}
                    className="dot"
                  ></div>
                  <p>AVAX</p>
                </div>
                <div className="row-right">
                  <div
                    style={{
                      background: "#4bb26c",
                    }}
                    className="dot"
                  ></div>
                  <p>USDT</p>
                </div>
              </PairTokens>
            </TitleChart>
            <ShowChart>
              <Chart
                options={datasChart.options}
                series={datasChart.series}
                height={350}
                type="bar"
              />
            </ShowChart>
            {shapeActive === 1 && (
              <WrapSliderPrice
                style={{
                  marginTop: "-10px",
                  padding: "0 10px",
                }}
              >
                <Slider
                  className="custom-slider"
                  tooltip={{ formatter: null }}
                  max={100000000}
                  onChange={(e: any) => {
                    setSigma(Number(e));
                  }}
                />
              </WrapSliderPrice>
            )}
          </BlockChart>
        )}
        <>
          <ButtonCommon
            disabled={!Number(amountX) || !Number(amountY) || loading}
            onClick={() => {
              if (address) {
                if (paramTX && paramTX?.length < 1) {
                  if (allowance?.allowanceX < Number(amountX)) {
                    handleApprove(1);
                  } else if (allowance?.allowanceY < Number(amountY)) {
                    handleApprove(2);
                  }
                } else {
                  handleAddLiquidity();
                }
              } else {
                open();
              }
            }}
          >
            {loading ? (
              <LoadingSpin />
            ) : (
              <>
                {address
                  ? allowance?.allowanceX > Number(amountX) &&
                    allowance?.allowanceY > Number(amountY) &&
                    Number(amountX) > 0 &&
                    Number(amountY) > 0
                    ? `Add Liquidity`
                    : allowance?.allowanceX < Number(amountX) && amountX
                    ? `Approve ${poolDetail?.tokenX?.symbol}`
                    : allowance?.allowanceY < Number(amountY) && amountY
                    ? `Approve ${poolDetail?.tokenY?.symbol}`
                    : !Number(amountX)
                    ? "Enter token X value"
                    : !Number(amountY)
                    ? "Enter token Y value"
                    : "Add Liquidity"
                  : "Please connect wallet"}
              </>
            )}
          </ButtonCommon>
        </>
      </SwapContent>
      <ModalOverlay
        component={
          <ChooseToken
            isFromModal={true}
            otherCurrentAssetKey={""}
            setCurrentAsset={(e: any) => {
              typeModal
                ? setTokenX(listTokens.find((item: any) => item.address === e))
                : setTokenY(listTokens.find((item: any) => item.address === e));
            }}
            setOtherCurrentAsset={setTokenY}
            setOpenFromModal={setOpenModal}
            setAmountFrom={() => {}}
            setAmountTo={() => {}}
            isLiq={true}
            isModal={1}
            setListFavorite={[]}
            listFavorite={[]}
          />
        }
        open={openModal}
        setOpen={setOpenModal}
        title={"Select a token"}
        width="400px"
      />
    </>
  );
};
export default FormAddLpV2;

const LIST_SHAPE = [
  {
    img: "/assets/images/liquidity/img-shape-spot.webp",
    label: "Spot",
  },
  {
    img: "/assets/images/liquidity/img-shape-curve.webp",
    label: "Curve",
  },
  {
    img: "/assets/images/liquidity/img-shape-bid.webp",
    label: "Bid-Ask",
  },
];

const TabsListPrice = [
  {
    title: "By Range",
    value: 1,
  },
  {
    title: "By Radius",
    value: 2,
  },
];
